import { useI18n } from '../../contexts/I18nContext'

export default function LanguageToggle() {
  const { locale, setLocale } = useI18n()

  return (
    <button
      onClick={() => setLocale(locale === 'en' ? 'pt-BR' : 'en')}
      className="flex items-center gap-1.5 px-2 py-1 rounded-lg text-xs font-medium text-warm-600 hover:text-warm-900 hover:bg-warm-100 transition-colors"
      title={locale === 'en' ? 'Mudar para Português' : 'Switch to English'}
    >
      <span className="text-sm">{locale === 'en' ? '🇧🇷' : '🇺🇸'}</span>
      <span className="hidden md:inline">{locale === 'en' ? 'PT' : 'EN'}</span>
    </button>
  )
}
